<template>
  <v-row align="center" justify="center" class="align-center justify-center">
    <v-col align="center" align-self="center" cols="12" sm="12" md="12" lg="12">
      <div id="container"></div>
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/exporting'
import Sunburst from 'highcharts/modules/sunburst'
Exporting(Highcharts)
Sunburst(Highcharts)
export default {
  props: ['chart','firstYear','lastYear'],
  name: "LandUseAndLandCoverOverviewChart",
  data(){ return{ loading: false } },
  watch:{
    chart(){
      if(this.chart.length > 0){
        this.dataSource()
      }
    }
  },
  computed:{
    classes(){ return this.$store.getters.classes },
  },
  methods: {
    async dataSource() {
      this.chartPreprocessing();
    },
    chartPreprocessing() {
      const elementId = 'container';
      let chart = document.getElementById(elementId)
      if (chart) {
        this.charts();
        chart.style.visibility = 'visible';
        chart.style.display = 'block';
      } else {
        chart.style.visibility = 'hidden';
        chart.style.display = 'none';
      }
    },
    async charts() {
      let data = this.chart;
      let total;
      if(data) {
        total = data.map(p => p.value || 0).reduce((a, b) => a + b);
      }
      Highcharts.chart('container', {
        chart: {
          height: '109%',
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          //height: (9 / 16 * 100) + '%', // 16:9 ratio
        },
        exporting: {enabled: false},
        credits: {
          enabled: true,
          href: 'http://www.simepar.br/',
          text:'by: SIMEPAR',
        },
        title: { text: null },
        subtitle: { text: null },
        // Let the center circle be transparent
        colors: ['transparent'].concat(Highcharts.getOptions().colors),
        caption: {
          text: `Gráfico de visão geral do uso e cobertura da terra de ${this.firstYear} até ${this.lastYear}`,
          style: { color: "#FFFFFF" },
        },
        series: [{
          type: 'sunburst',
          data: data,
          allowDrillToNode: true,
          cursor: 'pointer',
          drillUpButton: {
            text: "Restaurar o gráfico"
          },
          dataLabels: {
            format: '{point.name}',
            filter: {
              property: 'innerArcLength',
              operator: '>',
              value: 16
            },
            rotationMode: 'circular'
          },
          levels: [{
            level: 1,
            levelIsConstant: false,
            dataLabels: {
              filter: {
                property: 'outerArcLength',
                operator: '>',
                value: 64
              }
            }
          }, {
            level: 2,
            colorByPoint: true
          },
            {
              level: 3,
              colorVariation: {
                key: 'brightness',
                to: -0.5
              }
            }, {
              level: 4,
              colorVariation: {
                key: 'brightness',
                to: 0.5
              }
            }]
        }],
        tooltip: {
          headerFormat: '',
          formatter: function () {
            const point = this.point,
            series = this.series;
            let percentage = (point.value / total) * 100;
            const percentageNormalized = (Math.round(percentage * 100)/100)  + '%';
            const valueRounded = Math.round(point.value * 100)/100; // round 2 decimals
            return point.name +': <b>'+percentageNormalized+'</b> ('+ valueRounded +' ha)';
          }
        },
      });
    },
  },
}
</script>
